import {ADD_SECTION} from "../actions/addSection";
import {UPDATE_SECTION} from "../actions/update";
import {ADD_SLIDE} from "../actions/addSlide";
import {UPDATE_SLIDE} from "../actions/updateSlide";
import {ADD_ELEMENT} from "../actions/addElement";
import {UPDATE_ELEMENT} from "../actions/updateElement";
const firebase = require('firebase/app');
require('firebase/database');

export default function (state = {}, {type, payload}) {
    switch (type) {
        case ADD_SECTION: {
            const copy = Object.assign({}, state);
            const pushKey = firebase.database().ref('/').push().key;
            payload["key"] = pushKey;
            payload["position"] = Object.keys(state).length;
            copy[pushKey] = payload;
            return copy;
        }
        case UPDATE_SECTION: {
            const {object, key, attribute} = payload;
            const copy = Object.assign({}, state);
            copy[key][attribute] = object;
            return copy;
        }
        case ADD_SLIDE: {
            const pushKey = firebase.database().ref('/').push().key;
            const copy = JSON.parse(JSON.stringify(state));
            copy[payload]["slides"][pushKey] = "";
            return copy;
        }
        case UPDATE_SLIDE: {
            const {slideKey, parentKey, object} = payload;
            const copy = JSON.parse(JSON.stringify(state));
            copy[parentKey]["slides"][slideKey] = object;
            return copy;
        }
        case ADD_ELEMENT: {
            const pushKey = firebase.database().ref('/').push().key;
            const copy = JSON.parse(JSON.stringify(state));
            const elements = copy[payload]["elements"];
            elements[pushKey] = {
                content: "",
                position: Object.keys(elements).length,
                key: pushKey
            };
            return copy;
        }
        case UPDATE_ELEMENT: {
            const {parentKey, elementKey, object} = payload;
            const copy = JSON.parse(JSON.stringify(state));
            copy[parentKey]["elements"][elementKey]["content"] = object;
            return copy;
        }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/admin/components/editor/reducers/sections.js